import { createClient } from '@supabase/supabase-js'

// Эти данные ты найдешь в Supabase: Settings -> API
const supabaseUrl = 'https://ggokqmiscasujbiwrcxs.supabase.co' 
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imdnb2txbWlzY2FzdWpiaXdyY3hzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU0Njg0MDcsImV4cCI6MjA4MTA0NDQwN30.Ax2ewykTWtMbBVUvwYWkiitHjoOwv_xsLqpZpGk2aM4'

export const supabase = createClient(supabaseUrl, supabaseKey)